import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import PlusLineIcon from "@/components/icons/plus-line"
import PaymentLinksTable from "./payment-links.table"
import StatCard from "@/components/ux/stat.card"
import {
  PaymentLinkGet,
  usePaymentLinkStats,
  usePaymentLinksActions,
} from "@/api/payment-links"
import { useState } from "react"
import { CreatePaymentModal } from "@/payments/create-payment.modal"

export default function PaymentLinksListScreen() {
  const { stats } = usePaymentLinkStats()
  const { linkTransaction } = usePaymentLinksActions()
  const [createPaymentPaymentLink, setCreatePaymentPaymentLink] =
    useState<PaymentLinkGet | null>(null)

  const onLinkTransaction = async (txid: string) => {
    if (!createPaymentPaymentLink) throw new Error("No payment link selected")
    await linkTransaction(createPaymentPaymentLink.id, txid)
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-4 md:flex-row justify-between">
        <div className="text-xl font-semibold">Payment Links</div>
        <Button asChild>
          <Link to="/payment-links/create" data-testid="create-payment-link">
            <PlusLineIcon />
            Create Payment Link
          </Link>
        </Button>
      </div>
      {stats && (
        <div className="flex flex-col md:flex-row gap-4">
          <StatCard value={stats.total} label="All Payment Links" />
          <StatCard value={stats.active} label="Active" />
          <StatCard value={stats.inactive} label="Inactive" />
        </div>
      )}
      <PaymentLinksTable onLinkTransaction={setCreatePaymentPaymentLink} />
      {createPaymentPaymentLink && (
        <CreatePaymentModal
          onClose={() => setCreatePaymentPaymentLink(null)}
          onLinkTransaction={onLinkTransaction}
          description={`Link a transaction to payment link ${createPaymentPaymentLink.title}`}
        />
      )}
    </div>
  )
}
